import React from 'react';
import { CallActionsContainer } from './styles';
import MuteBtn from './MuteBtn';
import CallHandlerBtn from './CallHandlerBtn';
import PauseBtn from './PauseBtn';
import { useDialerContext } from '../DialerContext';

const CallActions = () => {
	const {
		handleCall,
		callNumber,
		handleHangup,
		callInProgress,
	} = useDialerContext();

	const IS_VALID_NUMBER = callNumber?.length === 15 || callNumber?.length === 14;

	if ( callInProgress ) {
		return (
			<CallActionsContainer>
				<MuteBtn />
				<CallHandlerBtn 
					handleCall={() => handleCall( callNumber )} 
					disableColor={false}
					handleHangup={handleHangup}
					sessionInProgress={callInProgress}
				/>
				<PauseBtn />
			</CallActionsContainer>
		);
	}

	return (
		<CallActionsContainer>
			<CallHandlerBtn
				handleCall={() => handleCall( callNumber )} 
				disableColor={IS_VALID_NUMBER}
				handleHangup={handleHangup}
				sessionInProgress={callInProgress}
			/>
		</CallActionsContainer>
	);
};

export default CallActions;